// extracted by mini-css-extract-plugin
export default {"zoomModal":"H3-z","image":"I3-z","button":"J3-z","isOverlayShown":"K3-z"};